import { render, staticRenderFns } from "./CandidatesMIJNBulk.vue?vue&type=template&id=6716c243&scoped=true&lang=pug"
import script from "./CandidatesMIJNBulk.vue?vue&type=script&lang=js"
export * from "./CandidatesMIJNBulk.vue?vue&type=script&lang=js"
import style0 from "./CandidatesMIJNBulk.vue?vue&type=style&index=0&id=6716c243&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6716c243",
  null
  
)

export default component.exports